exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".entryForm__heading{color:#000;font-size:18px;font-weight:400;text-align:center}.entryForm__heading>strong{font-size:20px;font-weight:700}.entryForm .inputted_param{color:#000;font-size:15px;line-height:1}.entryFormFooter{color:#fff;margin-left:-16px;margin-right:-16px;padding:16px;margin-top:3em}.editTab{text-align:center}.editTab__content{display:flex;border:1px solid #000;border-radius:4px;width:90%;max-width:303px;margin:20px auto;align-items:center;height:36px;overflow:hidden;font-size:13px}.editTab__item{cursor:pointer;line-height:40px;width:100%;color:#000}.editTab__item[data-active=true]{color:#fff;background:#000}.contentTitle{position:relative;background:#f8f8f8;font-size:12px;padding:7px 12px}.contentTitle p{margin:0}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/sass-loader/lib/loader.js!./resources/assets/js/utvStore/components/EntryForm/mixins/style.scss
// module id = +Z22
// module chunks = 0